import styled, { css } from 'styled-components';
import { Row, Col, Menu } from 'antd';

export const Container = styled.div`
  font-family: 'Maison Neue';
  margin-top: 0;
  /* position: fixed; */
  /* left: 220px; */
  /* width: calc(100% - 220px); */
  z-index: 10;
  background-color: #f9f9f9;
  /* top: 0; */
  /* height: 100vh; */
  /* display: flex; */
  /* flex-direction: column; */
  .row_work-operations > div > div {
    padding: 16px 0 0 0;
    h3 {
      margin-left: 15px;
    }
  }
`;

export const ColWithPadding = styled(Col)`
  padding: 8px;
`;
export const MainDiv = styled.div`
  /* overflow-y: scroll; */
`;

export const CreteBookingMenu = styled(Menu)`
  border: none;
  background-color: #f9f9f9;
  .ant-dropdown-menu-item {
    border-bottom: 1px solid #e8e8e8;
  }
  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu {
    padding: 16px;
    line-height: 14px;
    font-size: 14px;
  }
  .ant-dropdown-menu-submenu-title {
    padding: 0;
  }
  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu,
  .ant-dropdown-menu-submenu-title {
    &:hover {
      background: #f0f2f5;
    }
  }
`;

export const CreateBookingSubmenu = styled(Menu.Item)`
  padding: 16px;
  > .ant-dropdown-menu-item {
    margin-top: -15px !important;
    border: 1px solid blue;
  }
  &:hover {
    background: #f0f2f5;
  }
`;
